'use client'
import batIcon from '@/assets/images/icon/batIcon.svg'
import CustomLink from '@/shared/components/customLink'
import MyImage from '@/shared/components/myImage'
import { S3_PREFIX } from '@/shared/constants'
// import { ENUM_CRICKET_MATCH_PAGES } from '@/shared/enum'
import getStatus from '@/shared/hooks/useStatus'
import { replaceStringToShort } from '@/shared/utils'
import { useMemo } from 'react'

const scoreSplit = (score: any) => {
  if (score?.includes('&')) {
    let newScoreString = ''
    score.split('&').forEach((ele: any, i: number) => {
      if (i === 0 && ele) {
        const [score] = ele.split(' (')
        newScoreString += score + ' &'
      } else if (ele) {
        newScoreString += ele
      }
    })
    score = newScoreString
  }
  const scoreSplittedData = score?.split(' ')
  if (scoreSplittedData?.length > 0) {
    return (
      <span>
        {scoreSplittedData?.map((ele: string, i: number) => {
          if (ele.match(/\(|\)/) || ele.includes('&')) {
            return (
              <span key={ele + i} className="">
                {ele + ' '}
              </span>
            )
          } else {
            return <b key={ele + i}>{ele + ' '}</b>
          }
        })}
      </span>
    )
  }
}

export default function HeadToHead({ card }: any) {
  const { sStatusStr } = getStatus(card)

  // const rewriteURLs = useMemo(() => {
  //   const seriesUrls: Record<string, string> = {}
  //   card?.oMatchSeos?.oSeo?.forEach((e: { eSubType: string | undefined; sSlug: string }): void => {
  //     seriesUrls[ENUM_CRICKET_MATCH_PAGES[e?.eSubType || 'i']] = getSlugUrl(`/${e?.sSlug}`)
  //   })
  //   return seriesUrls
  // }, [sStatusStr])

  const TeamA = useMemo(
    () => (
      <div className={`font-extrabold flex gap-2.5 items-center`}>
        <div className="align-middle min-w-[25px] object-cover overflow-hidden">
          <MyImage
            loadOnScroll
            src={
              card?.oTeamScoreA?.oTeam?.oImg?.sUrl
                ? `${S3_PREFIX}${card?.oTeamScoreA?.oTeam?.oImg?.sUrl}`
                : ''
            }
            className="aspect-square rounded-full"
            placeholderType="team"
            alt={card?.oTeamScoreA?.oTeam?.sAbbr}
            width={25}
            height={25}
            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
          />
        </div>
        {sStatusStr !== 'scheduled' && sStatusStr !== 'cancelled' ? (
          <div className={`flex relative align-middle`}>
            <div className="text-sm text-textOffWhite font-medium md:font-bold">
              {card?.oTeamScoreA?.oTeam?.sAbbr}
            </div>
            {sStatusStr === 'live' && card?.oTeamScoreA?.sScoresFull?.includes('*') && (
              <div className="ml-1.5 w-4">
                <MyImage src={batIcon} alt="*" height={16} width={16} />
              </div>
            )}
          </div>
        ) : (
          <span className="ml-1.5 font-medium text-sm">{card?.oTeamScoreA?.oTeam?.sTitle}</span>
        )}
      </div>
    ),
    [card, sStatusStr]
  )

  const TeamB = useMemo(
    () => (
      <div className={`font-extrabold flex gap-2.5 items-center`}>
        <div className="align-middle">
          <MyImage
            loadOnScroll
            src={
              card?.oTeamScoreB?.oTeam?.oImg?.sUrl
                ? `${S3_PREFIX}${card?.oTeamScoreB?.oTeam?.oImg?.sUrl}`
                : ''
            }
            placeholderType="team"
            className="aspect-square rounded-full"
            alt={card?.oTeamScoreB?.oTeam?.sAbbr}
            width={25}
            height={25}
            sizes="(max-width: 767px) 24px, (max-width: 991px) 24px, (max-width: 1190px) 200px, 24px"
          />
        </div>
        {sStatusStr !== 'scheduled' && sStatusStr !== 'cancelled' ? (
          <div className={`flex relative align-middle text-sm`}>
            <div className="text-sm text-textOffWhite font-medium md:font-bol">
              {card?.oTeamScoreB?.oTeam?.sAbbr}
            </div>
            {sStatusStr === 'live' && card?.oTeamScoreB?.sScoresFull?.includes('*') && (
              <div className="ml-1.5 w-4">
                <MyImage src={batIcon} alt="*" height={16} width={16} />
              </div>
            )}
          </div>
        ) : (
          <span className="ml-1.5 font-medium text-sm">{card?.oTeamScoreB?.oTeam?.sTitle}</span>
        )}
      </div>
    ),
    [card, sStatusStr]
  )

  const TeamAscore = useMemo(
    () => (
      <p className="font-normal text-xs text-TextScoredCompplete flex items-center">
        <span>{scoreSplit(card?.oTeamScoreA?.sScoresFull)}</span>
        {card?.nLatestInningNumber > 1 &&
          (card?.oTeamScoreA?.sScoresFull?.includes('*') ? (
            <span className="font-bold text-textOffWhite">
              {scoreSplit(card?.oTeamScoreA?.sScoresFull)}
            </span>
          ) : (
            <span
              className={
                sStatusStr === 'completed' && card?.oTeamScoreA?.oTeam._id === card?.iWinnerId
                  ? 'text-textOffWhite font-bold'
                  : 'text-textDselected font-medium'
              }
            >
              {scoreSplit(card?.oTeamScoreA?.sScoresFull)}
            </span>
          ))}
      </p>
    ),
    [card, sStatusStr]
  )

  const TeamBscore = useMemo(
    () => (
      <p className="font-normal text-xs text-TextScoredCompplete flex items-center">
        <span>{scoreSplit(card?.oTeamScoreB?.sScoresFull)}</span>

        {card?.nLatestInningNumber > 1 &&
          (card?.oTeamScoreB?.sScoresFull?.includes('*') ? (
            <span className="font-bold text-textOffWhite">
              {scoreSplit(card?.oTeamScoreB?.sScoresFull)}
            </span>
          ) : (
            <span
              className={
                sStatusStr === 'completed' && card?.oTeamScoreB?.oTeam._id === card?.iWinnerId
                  ? 'text-textOffWhite font-bold'
                  : 'text-TextScoredCompplete font-medium'
              }
            >
              {scoreSplit(card?.oTeamScoreB?.sScoresFull)}
            </span>
          ))}
      </p>
    ),
    [card, sStatusStr]
  )
  // const handleClick = (sSlug: string) => {
  //   sSlug = sSlug?.replace('cricket/live-score', 'live-cricket-score')
  //   if (sStatusStr === 'live') return rewriteURLs?.['summary'] ?? `/${sSlug}`
  //   else if (sStatusStr === 'scheduled') return `/${sSlug}`
  //   else if (sStatusStr === 'completed' || sStatusStr === 'cancelled')
  //     return rewriteURLs?.['summary'] ?? `/${sSlug}`
  //   return ''
  // }
  return (
    <div className="relative">
      <CustomLink
        href={`/${card?.oSeo?.sSlug || ''}`}
        passHref
        className="h-full w-full absolute top-0 left-0 opacity-0 z-10"
        prefetch={false}
      >
        {card?.sTitle}
      </CustomLink>
      <div className="pb-0 pt-3 px-2 md:px-4 md:p-3.5 dark:md:bg-headersActive md:bg-[#FCFCFC] rounded-t-xl">
        <p className="flex items-center text-ellipsis whitespace-nowrap">
          <span className="text-xs text-[#999999] font-normal">Diamond Oval, Kimberley</span>
          {card?.sSubtitle && (
            <>
              <span className="h-1.5 w-1.5 rounded-full bg-[#353535] mx-2"></span>
              <span className="text-xs font-normal text-TextScoredCompplete ">
                {card?.sSubtitle}{' '}
              </span>
            </>
          )}
        </p>
      </div>
      <div className="grid grid-cols-12 px-2 md:px-4 pb-4 pt-3">
        <div className={`col-span-8 pr-1 md:pr-7`}>
          <div className="flex justify-between mb-3 md:mb-3.5 relative">
            {/* Team A */}
            {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam._id && sStatusStr === 'live'
              ? TeamB
              : TeamA}
            {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam._id && sStatusStr === 'live'
              ? TeamBscore
              : TeamAscore}
          </div>
          <div className="flex justify-between mb-0 md:mb-3.5 relative">
            {/* Team B */}
            {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam._id && sStatusStr === 'live'
              ? TeamA
              : TeamB}
            {card?.iBattingTeamId === card?.oTeamScoreB?.oTeam._id && sStatusStr === 'live'
              ? TeamAscore
              : TeamBscore}
          </div>
          <div className=" hidden md:flex items-center gap-4">
            <CustomLink href="#" className="text-xs text-[#80878D]">
              Scorecard
            </CustomLink>
            <CustomLink href="#" className="text-xs text-[#80878D]">
              Fixture
            </CustomLink>
          </div>
        </div>
        <div className="col-span-4 px-1.5 border-l border-borderStroke md:border-tabBorder flex items-center justify-center text-center">
          <p
            className={` font-normal ${
              sStatusStr === 'cancelled'
                ? '!text-danger font-medium'
                : sStatusStr !== 'completed'
                  ? 'text-ScheduledBG'
                  : '!text-successNew'
            }  text-sm overflow-hidden`}
          >
            {sStatusStr === 'completed' &&
              replaceStringToShort(
                card?.oTeamScoreA?.oTeam,
                card?.oTeamScoreB?.oTeam,
                card?.sStatusNote
              )}
            {sStatusStr === 'cancelled' &&
              (replaceStringToShort(
                card?.oTeamScoreA?.oTeam,
                card?.oTeamScoreB?.oTeam,
                card?.sStatusNote
              ) ||
                'MatchAbandoned')}
          </p>
        </div>
      </div>
    </div>
  )
}
